import '../css/Nav.scss';const PageTitle = ({title}) => {
	return (
		<h1 className="primary_title">{title}</h1>
	);
};

export default PageTitle;